import React from "react";
import { Button } from "@mui/material";
import {
  StyledLoadingdiv,
  StyledProgressdiv,
  StyledProgressPercentage,
} from "./ProgressBar.style";
import axios from "axios";
import Toast from "helper/toast";

export default function ProgressBarCM(props) {
  // const cancelUploadHandler = () => {
  //   let source = axios.CancelToken.source();
  //   axios
  //     .post(
  //       props.url,
  //       { data: props.data },
  //       {
  //         cancelToken: source.token,
  //       }
  //     )
  //     .catch(function (thrown) {
  //       if (axios.isCancel(thrown)) {
  //         Toast({ type: "success", title: "لغو آپلود فایل " });
  //       } else {
  //         Toast({ type: "err", title: "لغو آپلود فایل " });
  //       }
  //     });

  //   source.cancel("axios request canceled");
  // };

  return (
    <StyledLoadingdiv>
      <label htmlFor="file"> در حال بارگذاری </label>
      <StyledProgressdiv id="file" value={props.value} max="100" />
      <StyledProgressPercentage>
        {`% ${Math.trunc(props.value)}`}
      </StyledProgressPercentage>
      {/* <Button variant="contained" color="error" onClick={cancelUploadHandler}>
        لغو
      </Button> */}
    </StyledLoadingdiv>
  );
}
